/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Admins.Api
 * OpenAPI spec version: 1.0
 */
export interface AddressApiContract {
  /** @nullable */
  StreetAddress1?: string | null;
  /** @nullable */
  StreetAddress2?: string | null;
  /** @nullable */
  City?: string | null;
  /** @nullable */
  Zip?: string | null;
  /**
   * 2 digits
   * @nullable
   */
  StateCode?: string | null;
  /**
   * 2 digits
   * @nullable
   */
  CountryCode?: string | null;
}

export interface AdminApiInContract {
  /** @nullable */
  Email?: string | null;
  /** @nullable */
  FirstName?: string | null;
  /** @nullable */
  LastName?: string | null;
  /** @nullable */
  Prefix?: string | null;
  /** @nullable */
  Suffix?: string | null;
}

export interface AdminApiOutContract {
  /** @nullable */
  UserId?: string | null;
  /** @nullable */
  Email?: string | null;
  /** @nullable */
  FirstName?: string | null;
  /** @nullable */
  LastName?: string | null;
  /** @nullable */
  Prefix?: string | null;
  /** @nullable */
  Suffix?: string | null;
  /** @nullable */
  ImageUrl?: string | null;
  IsVerified?: boolean;
  IsActive?: boolean;
}

/**
 * The set of admin permissions. Each member's string value matches a seeded
`Admin.Permissions.Name` row and must be kept in sync with that seed data.
 */
export type AdminPermission = typeof AdminPermission[keyof typeof AdminPermission];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminPermission = {
  patientblock: 'patient.block',
  patientchangeemail: 'patient.changeemail',
  patientmediafiledelete: 'patient.mediafile.delete',
  adminpermissionsmanage: 'admin.permissions.manage',
  prescriptionstatusmanage: 'prescription.status.manage',
  patientpackageedit: 'patient.package.edit',
  prescriptionencountercreate: 'prescription.encounter.create',
  visitmedicalrecordsdelete: 'visit.medicalrecords.delete',
} as const;

export interface AdminPermissionsApiInContract {
  /** @nullable */
  Permissions?: AdminPermission[] | null;
}

export interface AdminPermissionsApiOutContract {
  /** @nullable */
  Permissions?: AdminPermission[] | null;
}

export interface ApplicationSettingsAdminApiOutContract {
  /** @nullable */
  SettingsPerState?: ApplicationSettingsPerStateAdminApiContract[] | null;
}

export interface ApplicationSettingsPerStateAdminApiContract {
  /** @nullable */
  StateCode?: string | null;
  IsPhoneVisitCommunicationTypeAllowed?: boolean;
  /** @nullable */
  DrugScreenHtml?: string | null;
}

export interface AuthTokenApiContract {
  /** @nullable */
  AccessToken: string | null;
}

export interface AuthTokenPairApiContract {
  /** @nullable */
  AccessToken?: string | null;
  /** @nullable */
  RefreshToken?: string | null;
}

export interface AuthorApiOutContract {
  /** @nullable */
  FirstName?: string | null;
  /** @nullable */
  LastName?: string | null;
  /** @nullable */
  Prefix?: string | null;
  /** @nullable */
  Suffix?: string | null;
}

export interface AuthorWithTypeApiOutContract {
  /** @nullable */
  FirstName?: string | null;
  /** @nullable */
  LastName?: string | null;
  /** @nullable */
  Prefix?: string | null;
  /** @nullable */
  Suffix?: string | null;
  /** @nullable */
  UserType?: string | null;
}

export interface AvailableAdminPermissionsApiOutContract {
  /** @nullable */
  Permissions?: AdminPermission[] | null;
}

export interface CancelOrderAdminApiInContract {
  /** @nullable */
  OrderId?: string | null;
  /** @nullable */
  PatientId?: string | null;
  /** @nullable */
  ReasonId: string | null;
  /** @nullable */
  Comment?: string | null;
}

export interface CancelVisitAdminApiInContract {
  ReasonId: string;
  /** @nullable */
  Comment?: string | null;
}

export interface ChangeDoctorCalendarOccurrencesStaffApiInContract {
  /**
   * Collection of occurrences to create.
   * @nullable
   */
  Create?: CreateDoctorCalendarOccurrenceStaffApiInContract[] | null;
  /**
   * Collection of occurrences to edit.
   * @nullable
   */
  Edit?: EditDoctorCalendarOccurrenceStaffApiInContract[] | null;
  /**
   * Collection of occurrence ids to delete.
   * @nullable
   */
  Delete?: string[] | null;
}

export interface ChangeDoctorCalendarSchedulesStaffApiInContract {
  /**
   * Collection of schedules to create.
   * @nullable
   */
  Create?: CreateDoctorCalendarScheduleStaffApiInContract[] | null;
  /**
   * Collection of schedules to edit.
   * @nullable
   */
  Edit?: EditDoctorCalendarScheduleStaffApiInContract[] | null;
  /**
   * Collection of schedule ids to delete.
   * @nullable
   */
  Delete?: string[] | null;
}

/**
 * @nullable
 */
export type ChangeDoctorCalendarStaffApiInContractSchedules = ChangeDoctorCalendarSchedulesStaffApiInContract | null;

/**
 * @nullable
 */
export type ChangeDoctorCalendarStaffApiInContractOccurrences = ChangeDoctorCalendarOccurrencesStaffApiInContract | null;

export interface ChangeDoctorCalendarStaffApiInContract {
  /** Required, Valid value in IANA or Windows format */
  TimeZone: string;
  /** @nullable */
  Schedules?: ChangeDoctorCalendarStaffApiInContractSchedules;
  /** @nullable */
  Occurrences?: ChangeDoctorCalendarStaffApiInContractOccurrences;
}

export interface ChangeDoctorProductivityOverridesAdminApiInContract {
  /** @nullable */
  Create?: DoctorProductivityOverrideAdminApiContract[] | null;
  /** @nullable */
  Delete?: string[] | null;
}

export interface ChangePasswordApiInContract {
  /** @nullable */
  CurrentPassword?: string | null;
  /** @nullable */
  NewPassword?: string | null;
}

export interface ConsentFormAdminApiOutContract {
  /** @nullable */
  ConsentFormId: string | null;
  /** @nullable */
  Name: string | null;
  /** @nullable */
  Url: string | null;
  IndividualConsentRequired: boolean;
}

export interface CounterSummaryApiContract {
  Count?: number;
}

/**
 * @nullable
 */
export type CreateDoctorAdminApiInContractPhoneNumber = PhoneApiContract | null;

export interface CreateDoctorAdminApiInContract {
  /** @nullable */
  Email?: string | null;
  /** @nullable */
  FirstName?: string | null;
  /** @nullable */
  LastName?: string | null;
  /** @nullable */
  Prefix?: string | null;
  /** @nullable */
  Suffix?: string | null;
  IsExcludedFromMarketingReports?: boolean;
  /** @nullable */
  NationalProviderIdentifier?: string | null;
  /** @nullable */
  ProfessionalTitles?: string[] | null;
  /** @nullable */
  ProductivityOverrides?: DoctorProductivityOverrideAdminApiContract[] | null;
  /** @nullable */
  Licenses?: DoctorLicenseAdminApiInContract[] | null;
  /** @nullable */
  PhoneNumber?: CreateDoctorAdminApiInContractPhoneNumber;
}

export interface CreateDoctorCalendarOccurrenceStaffApiInContract {
  Type: string;
  /** Minutes must be a multiple of 15. Seconds\Milliseconds are ignored */
  FromDateTime: string;
  /** Minutes must be a multiple of 15, Greater than FromDateTime in range from 15 mins to 24h. Seconds\Milliseconds are ignored. */
  ToDateTime: string;
  /**
   * List of overridden state codes. Collection of 2 letters codes of USA states. Can have only state codes provider is licensed in. If array is null or empty -- schedule will be created without override
   * @nullable
   */
  StateCodes?: string[] | null;
  /**
   * Id of VisitTypeGroup to assign for visitType filtering. If null, the default VisitTypeGroup will be used.
   * @nullable
   */
  VisitTypeGroupId?: string | null;
  /**
   * Global key of the treatment center for an in-person block. If null, the block has no treatment center
(and inherits the parent schedule's treatment center when it belongs to one).
   * @nullable
   */
  TreatmentCenterId?: string | null;
}

export interface CreateDoctorCalendarScheduleStaffApiInContract {
  /** Minutes must be a multiple of 15. Seconds\Milliseconds are ignored */
  FromDateTime: string;
  /** Minutes must be a multiple of 15, Greater than FromDateTime in range from 15 mins to 24h. Seconds\Milliseconds are ignored. */
  ToDateTime: string;
  /**
   * List of overridden state codes. Collection of 2 letters codes of USA states. Can have only state codes provider is licensed in. If array is null or empty -- schedule will be created without override
   * @nullable
   */
  StateCodes?: string[] | null;
  /**
   * Id of VisitTypeGroup to assign for visitType filtering. If null, the default VisitTypeGroup will be used.
   * @nullable
   */
  VisitTypeGroupId?: string | null;
  /** Recurrence settings for the schedule. */
  RecurringSettings: DoctorCalendarScheduleRecurringSettingsStaffApiContract;
  /**
   * Optional global key of the treatment center to associate with this schedule.
   * @nullable
   */
  TreatmentCenterId?: string | null;
}

export interface CreateVisitAdminApiInContract {
  /** @nullable */
  ProviderId?: string | null;
  /** @nullable */
  PatientId?: string | null;
  /** @nullable */
  VisitTypeId?: string | null;
  /** @nullable */
  Method?: string | null;
  /** @nullable */
  DateTime?: string | null;
  Price?: number;
  /** @nullable */
  CreditCardId?: string | null;
  /** @nullable */
  CreditCardCvc?: string | null;
  VisitCreditAmount?: number;
  /** @nullable */
  TimeZone?: string | null;
  /** @nullable */
  StateCode?: string | null;
}

export type CreditReasonLookupItemOutContract = LookupItemOutContract & {
  /** @nullable */
  CreditExpiresAtUtc?: string | null;
};

export type CreditType = typeof CreditType[keyof typeof CreditType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreditType = {
  standard: 'standard',
  referral: 'referral',
} as const;

export interface DateTimeRangeApiContract {
  /**
   * Date and time to load calendar from. Must be encoded to be used in url. Example of encoded state: 2022-07-21T00%3A00%3A00.000%2B00%3A00.
   * @nullable
   */
  FromDateTime?: string | null;
  /**
   * toDateTime	Date and time to load calendar to. Must be encoded to be used in url. Must be greater than fromDateTime. Example of encoded state: 2022-07-21T00%3A00%3A00.000%2B00%3A00.
   * @nullable
   */
  ToDateTime?: string | null;
}

/**
 * Error response returned when a fulfillment partner cannot be deactivated
because it is the only fulfillment option for one or more medications.
 */
export interface DeactivateFulfillmentPartnerErrorContract {
  /** The error code: "FulfillmentPartnerSingleOptionForMedication". */
  ErrorCode: string;
  /** List of medication global keys that would be left without
a fulfillment partner if this partner were deactivated. */
  Data: string[];
}

export interface DeadLetterQueueDepthAdminApiOutContract {
  /** @nullable */
  Key: string | null;
  Depth: number;
}

export interface DeadLetterReplayAdminApiOutContract {
  /** @nullable */
  Key: string | null;
  Replayed: number;
}

export interface DeleteVisitMedicalRecordsAdminApiInContract {
  Reason: string;
}

/**
 * @nullable
 */
export type DoctorAdminApiOutContractPhoneNumber = PhoneApiContract | null;

export interface DoctorAdminApiOutContract {
  /** @nullable */
  UserId?: string | null;
  /** @nullable */
  Email?: string | null;
  /** @nullable */
  FirstName?: string | null;
  /** @nullable */
  LastName?: string | null;
  /** @nullable */
  Prefix?: string | null;
  /** @nullable */
  Suffix?: string | null;
  /** @nullable */
  ImageUrl?: string | null;
  IsExcludedFromMarketingReports?: boolean;
  IsVerified?: boolean;
  IsActive?: boolean;
  /** @nullable */
  ProfessionalTitles?: string[] | null;
  /** @nullable */
  ProductivityOverrides?: DoctorProductivityOverrideAdminApiContract[] | null;
  /** @nullable */
  NationalProviderIdentifier?: string | null;
  /** @nullable */
  Licenses?: DoctorLicenseAdminApiOutContract[] | null;
  /** @nullable */
  PhoneNumber?: DoctorAdminApiOutContractPhoneNumber;
}

/**
 * VisitTypeGroup that limits available VisitTypes for booking for the given schedule. null means all licensed VisitTypes available for booking
 * @nullable
 */
export type DoctorCalendarScheduleApiStaffOutContractVisitTypeGroup = ScheduleVisitTypeGroupStaffApiOutContract | null;

/**
 * Optional treatment center tied to availability block
 * @nullable
 */
export type DoctorCalendarScheduleApiStaffOutContractTreatmentCenter = TreatmentCenterApiOutContract | null;

export interface DoctorCalendarScheduleApiStaffOutContract {
  ScheduleId: string;
  /** Windows id of timezone schedule was created on */
  TimeZone: string;
  /** Date and time when schedule starts */
  FromDateTime: string;
  /** Date and time when schedule ends */
  ToDateTime: string;
  /** Collection of 2 letter USA state codes the schedule is overridden for. Field has value only if whole schedule is overridden for certain state(s). */
  StateCodes: string[];
  /**
   * VisitTypeGroup that limits available VisitTypes for booking for the given schedule. null means all licensed VisitTypes available for booking
   * @nullable
   */
  VisitTypeGroup?: DoctorCalendarScheduleApiStaffOutContractVisitTypeGroup;
  /** Recurring settings of schedule */
  RecurringSettings: DoctorCalendarScheduleRecurringSettingsStaffApiContract;
  /**
   * Optional treatment center tied to availability block
   * @nullable
   */
  TreatmentCenter?: DoctorCalendarScheduleApiStaffOutContractTreatmentCenter;
}

export interface DoctorCalendarScheduleRecurringSettingsStaffApiContract {
  /** Required. Can contain [monday, tuesday, wednesday, thursday, friday, saturday, sunday] */
  WeekDays: string[];
  /**
   * End date of recurring
   * @nullable
   */
  EndDateTime?: string | null;
}

export interface DoctorLicenseAdminApiInContract {
  /** @nullable */
  Number?: string | null;
  /** @nullable */
  StateCode?: string | null;
  /** @nullable */
  DeaNumber?: string | null;
  /** @nullable */
  DeaStateCode?: string | null;
  /** @nullable */
  CslNumber?: string | null;
  /** @nullable */
  VisitTypes?: DoctorLicenseVisitTypeAdminApiInContract[] | null;
  IsVisibilityBatchChange?: boolean;
}

export interface DoctorLicenseAdminApiOutContract {
  /** @nullable */
  LicenseId?: string | null;
  /** @nullable */
  Number?: string | null;
  /** @nullable */
  StateCode?: string | null;
  /** @nullable */
  DeaNumber?: string | null;
  /** @nullable */
  DeaStateCode?: string | null;
  /** @nullable */
  CslNumber?: string | null;
  /** @nullable */
  VisitTypes?: DoctorLicenseVisitTypeAdminApiOutContract[] | null;
}

export interface DoctorLicenseVisitTypeAdminApiInContract {
  /** @nullable */
  VisitTypeId?: string | null;
  /** @nullable */
  VisibilityType?: string | null;
}

export interface DoctorLicenseVisitTypeAdminApiOutContract {
  /** @nullable */
  VisitTypeId?: string | null;
  /** @nullable */
  BaseVisibility?: string | null;
  /** @nullable */
  VisibilityOverride?: string | null;
  /** @nullable */
  TreatmentCenters?: TreatmentCenterApiOutContract[] | null;
}

export interface DoctorProductivityOverrideAdminApiContract {
  /** @nullable */
  VisitTypeId?: string | null;
  /** @nullable */
  Duration?: number | null;
  IsExemptFromNewPatientSpacing?: boolean;
  /** @nullable */
  MaxConsecutiveNewPatientVisits?: number | null;
}

export interface DoctorScheduleRangeAdminApiOutContract {
  /** @nullable */
  StartDateTime?: string | null;
  /** @nullable */
  EndDateTime?: string | null;
}

export interface EditDoctorCalendarOccurrenceStaffApiInContract {
  OccurrenceId?: string;
  /** Minutes must be a multiple of 15. Seconds\Milliseconds are ignored */
  FromDateTime?: string;
  /** Minutes must be a multiple of 15, Greater than FromDateTime in range from 15 mins to 24h. Seconds\Milliseconds are ignored. */
  ToDateTime?: string;
  /** List of overridden state codes. Collection of 2 letters codes of USA states. Can have only state codes provider is licensed in. If array is null or empty -- schedule will be created without override */
  StateCodes?: string[];
  /**
   * Id of VisitTypeGroup to assign for visitType filtering. If null, the default VisitTypeGroup will be used.
   * @nullable
   */
  VisitTypeGroupId?: string | null;
  /**
   * Global key of the treatment center for an in-person block. If null, the block has no treatment center
(and inherits the parent schedule's treatment center when it belongs to one).
   * @nullable
   */
  TreatmentCenterId?: string | null;
}

export interface EditDoctorCalendarScheduleStaffApiInContract {
  ScheduleId: string;
  /** Minutes must be a multiple of 15. Seconds\Milliseconds are ignored */
  FromDateTime: string;
  /** Minutes must be a multiple of 15, Greater than FromDateTime in range from 15 mins to 24h. Seconds\Milliseconds are ignored. */
  ToDateTime: string;
  /**
   * List of overridden state codes. Collection of 2 letters codes of USA states. Can have only state codes provider is licensed in. If array is null or empty -- schedule will be created without override
   * @nullable
   */
  StateCodes?: string[] | null;
  /**
   * Id of VisitTypeGroup to assign for visitType filtering. If null, the default VisitTypeGroup will be used.
   * @nullable
   */
  VisitTypeGroupId?: string | null;
  /** Recurrence settings for the schedule. */
  RecurringSettings: DoctorCalendarScheduleRecurringSettingsStaffApiContract;
  /**
   * Optional global key of the treatment center to associate with this schedule.
   * @nullable
   */
  TreatmentCenterId?: string | null;
}

export interface EmailApiContract {
  /** @nullable */
  Email?: string | null;
}

export interface EmbeddableTokenOutContract {
  /** @nullable */
  Token: string | null;
}

export interface EncounterUrlStaffApiOutContract {
  /** @nullable */
  ProfileUrl: string | null;
}

export interface EncryptedCreditCardMetadataApiContract {
  CardNumber?: string;
  ExpirationMonth?: string;
  ExpirationYear?: string;
  SecurityCode?: string;
}

export interface ErrorApiOutContract {
  /** @nullable */
  ErrorCode?: string | null;
}

export interface ErrorDescription {
  StatusCode?: HttpStatusCode;
  /** @nullable */
  ErrorCode?: string | null;
}

export interface FormulationApiContract {
  Price: number;
  TotalQuantity: number;
}

export interface FulfillmentPartnerAdminApiContract {
  Name: string;
  NcpdpId: string;
  /** Controls whether a delivery signature is required when shipping medications from a fulfillment partner. */
  SignatureRequirement: SignatureRequirementContract;
  ExcludedStateCodes: string[];
  ShippingOptions?: ShippingOptionAdminApiContract[];
}

/**
 * VisitTypeGroup that limits available VisitTypes for booking for the given occurrence. null means all licensed VisitTypes available for booking
 * @nullable
 */
export type GetDoctorCalendarOccurrenceItemAdminApiOutContractVisitTypeGroup = ScheduleVisitTypeGroupStaffApiOutContract | null;

/**
 * Optional treatment center tied to this availability block
 * @nullable
 */
export type GetDoctorCalendarOccurrenceItemAdminApiOutContractTreatmentCenter = TreatmentCenterApiOutContract | null;

export interface GetDoctorCalendarOccurrenceItemAdminApiOutContract {
  /** Unique identity of occurrence */
  OccurrenceId?: string;
  /**
   * Unique identity of recurring schedule. null for one-time occurrences
   * @nullable
   */
  ScheduleId?: string | null;
  /**
   * Ordered number of occurrence in a scope of schedule (starting with 0). Can be used by client side in case when need to understand is it first occurrence in schedule. null for one-time occurrences
   * @nullable
   */
  ScheduleOrderNumber?: number | null;
  /** Date and time when range starts */
  FromDateTime?: string;
  /** Date and time when range ends */
  ToDateTime?: string;
  /** Collection of 2 letter USA state codes the schedule occurrence is set for. Value is historical for the past. Can be empty if provider has no licenses */
  StateCodes?: string[];
  /**
   * VisitTypeGroup that limits available VisitTypes for booking for the given occurrence. null means all licensed VisitTypes available for booking
   * @nullable
   */
  VisitTypeGroup?: GetDoctorCalendarOccurrenceItemAdminApiOutContractVisitTypeGroup;
  /**
   * Optional treatment center tied to this availability block
   * @nullable
   */
  TreatmentCenter?: GetDoctorCalendarOccurrenceItemAdminApiOutContractTreatmentCenter;
  /** Flag shows is set of states overridden for certain occurrence */
  IsOverridden?: boolean;
  /** Flag shows is set of states same with all licensed states for provider. Value is historical for the past */
  IsAppliedForAllLicensedStates?: boolean;
}

export interface GetDoctorCalendarOccurrenceItemAdminApiOutContractGetDoctorCalendarStaffApiOutContract {
  /** @nullable */
  Availability?: GetDoctorCalendarOccurrenceItemAdminApiOutContract[] | null;
  /** @nullable */
  Unavailability?: GetDoctorCalendarOccurrenceItemAdminApiOutContract[] | null;
  /** @nullable */
  Visits?: GetDoctorCalendarVisitItemStaffApiOutContract[] | null;
}

export interface GetDoctorCalendarVisitItemStaffApiOutContract {
  /** @nullable */
  VisitId?: string | null;
  /** @nullable */
  FromDateTime?: string | null;
  /** @nullable */
  ToDateTime?: string | null;
  /** @nullable */
  PatientFirstName?: string | null;
  /** @nullable */
  PatientLastName?: string | null;
  IsNewPatientVisit?: boolean;
}

export interface GetPatientSubscriptionEntitlementApiOutContract {
  EntitlementId?: number;
  RemainingQuantity?: number;
  Price?: number;
  /** @nullable */
  ValidUntilDateTimeUtc?: string | null;
}

export interface GetPatientSubscriptionsApiOutContract {
  /** @nullable */
  SubscriptionGlobalKey?: string | null;
  /** @nullable */
  SubscriptionName?: string | null;
  Price?: number;
  /** @nullable */
  PatientSubscriptionGlobalKey?: string | null;
  /** @nullable */
  RecurringPaymentInterval?: string | null;
  /** @nullable */
  StartDateUtc?: string | null;
  /** @nullable */
  EndDateUtc?: string | null;
  /** @nullable */
  NextPaymentDateUtc?: string | null;
  /** @nullable */
  PreviousPaymentDateUtc?: string | null;
  /** @nullable */
  Entitlements?: GetPatientSubscriptionEntitlementApiOutContract[] | null;
}

export interface GetScheduledDoctorItemAdminApiOutContract {
  /** @nullable */
  DoctorId?: string | null;
  /** @nullable */
  FirstName?: string | null;
  /** @nullable */
  LastName?: string | null;
  /** @nullable */
  Prefix?: string | null;
  /** @nullable */
  Suffix?: string | null;
  /** @nullable */
  ImageUrl?: string | null;
  IsActive?: boolean;
  /** @nullable */
  StateCodes?: string[] | null;
  /** @nullable */
  VisitTypes?: ScheduledDoctorVisitTypeAdminApiOutContract[] | null;
  /** @nullable */
  Availability?: ScheduledDoctorAvailabilityDateTimeRangeAdminApiOutContract[] | null;
  /** @nullable */
  Unavailability?: DateTimeRangeApiContract[] | null;
}

export interface GetScheduledDoctorItemAdminApiOutContractPaginationItemCollectionApiOutContract {
  /** @nullable */
  Items?: GetScheduledDoctorItemAdminApiOutContract[] | null;
  TotalCount?: number;
}

/**
 * A grant program covering a visit. Unlike a package there is no allowance or position to report - the grant funds
the visit outright - so only its name is shown. Shared by the patient, provider and admin APIs.
 */
export interface GrantProgramVisitCoverageApiOutContract {
  /** @nullable */
  Name?: string | null;
}

export type HttpStatusCode = typeof HttpStatusCode[keyof typeof HttpStatusCode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HttpStatusCode = {
  NUMBER_100: 100,
  NUMBER_101: 101,
  NUMBER_102: 102,
  NUMBER_103: 103,
  NUMBER_200: 200,
  NUMBER_201: 201,
  NUMBER_202: 202,
  NUMBER_203: 203,
  NUMBER_204: 204,
  NUMBER_205: 205,
  NUMBER_206: 206,
  NUMBER_207: 207,
  NUMBER_208: 208,
  NUMBER_226: 226,
  NUMBER_300: 300,
  NUMBER_301: 301,
  NUMBER_302: 302,
  NUMBER_303: 303,
  NUMBER_304: 304,
  NUMBER_305: 305,
  NUMBER_306: 306,
  NUMBER_307: 307,
  NUMBER_308: 308,
  NUMBER_400: 400,
  NUMBER_401: 401,
  NUMBER_402: 402,
  NUMBER_403: 403,
  NUMBER_404: 404,
  NUMBER_405: 405,
  NUMBER_406: 406,
  NUMBER_407: 407,
  NUMBER_408: 408,
  NUMBER_409: 409,
  NUMBER_410: 410,
  NUMBER_411: 411,
  NUMBER_412: 412,
  NUMBER_413: 413,
  NUMBER_414: 414,
  NUMBER_415: 415,
  NUMBER_416: 416,
  NUMBER_417: 417,
  NUMBER_421: 421,
  NUMBER_422: 422,
  NUMBER_423: 423,
  NUMBER_424: 424,
  NUMBER_426: 426,
  NUMBER_428: 428,
  NUMBER_429: 429,
  NUMBER_431: 431,
  NUMBER_451: 451,
  NUMBER_500: 500,
  NUMBER_501: 501,
  NUMBER_502: 502,
  NUMBER_503: 503,
  NUMBER_504: 504,
  NUMBER_505: 505,
  NUMBER_506: 506,
  NUMBER_507: 507,
  NUMBER_508: 508,
  NUMBER_510: 510,
  NUMBER_511: 511,
} as const;

export interface IcdCodeStaffApiOutContract {
  /** @nullable */
  IcdCodeId?: string | null;
  /** @nullable */
  Code?: string | null;
  /** @nullable */
  Description?: string | null;
}

export interface ImageApiOutContract {
  /** @nullable */
  ImageUrl?: string | null;
}

export type InPersonComplianceStatusOutContract = typeof InPersonComplianceStatusOutContract[keyof typeof InPersonComplianceStatusOutContract];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InPersonComplianceStatusOutContract = {
  none: 'none',
  compliant: 'compliant',
  soon: 'soon',
  overdue: 'overdue',
} as const;

export interface IntakeFormListItemStaffApiOutContract {
  /** @nullable */
  IntakeFormId?: string | null;
  /** @nullable */
  CompleteDateTime?: string | null;
  /** @nullable */
  Name?: string | null;
  /** @nullable */
  VisitTypeName?: string | null;
}

export interface IntakeFormStaffApiOutContract {
  /** @nullable */
  IntakeFormId?: string | null;
  /** @nullable */
  CompleteDateTime?: string | null;
}

export interface IntakeFormTemplateAdminApiOutContract {
  /** @nullable */
  IntakeFormId?: string | null;
  /** @nullable */
  Name?: string | null;
  /** @nullable */
  Questions?: unknown[] | null;
}

export interface LookupItemOutContract {
  /** @nullable */
  Id?: string | null;
  /** @nullable */
  Text?: string | null;
  /** @nullable */
  Description?: string | null;
}

export type LookupType = typeof LookupType[keyof typeof LookupType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LookupType = {
  ordercancellationreasons: 'ordercancellationreasons',
  standardcreditreasons: 'standardcreditreasons',
  referralcreditreasons: 'referralcreditreasons',
  packageupdatereasons: 'packageupdatereasons',
  visitcancellationreasons: 'visitcancellationreasons',
} as const;

/**
 * @nullable
 */
export type MagicLinkLoginWebApiInContractClientInfo = WebClientInfoContract | null;

export interface MagicLinkLoginWebApiInContract {
  /** @nullable */
  TelemetryId?: string | null;
  /** @nullable */
  Token?: string | null;
  /** @nullable */
  ClientInfo?: MagicLinkLoginWebApiInContractClientInfo;
}

export interface MarkPrescriptionAsSentAdminApiInContract {
  /** @nullable */
  PrescriptionId?: string | null;
  /** @nullable */
  PatientId?: string | null;
}

export interface MediaFileDrugScreenStaffApiInContract {
  /** @nullable */
  CompleteDate?: string | null;
  /** @nullable */
  ExpireDate?: string | null;
}

export interface MedicationAdminApiInContract {
  Name: string;
  /** @nullable */
  NationalDrugCode?: string | null;
  /** @nullable */
  GenericCodeNumber?: string | null;
  /** @nullable */
  AlternativeThirdPartyKey?: string | null;
  IsControlledSubstance?: boolean;
  DispenseUnit: string;
  /** Broad classification of service types. Each category can have its own
QuickMD.Constants.LifecycleRuleSet governing lifecycle state transitions. */
  Category: ServiceCategory;
  PatientDescription: string;
  ImageUrl: string;
  FulfillmentPartnerNcpdpIds: string[];
  Formulations: FormulationApiContract[];
}

export interface MedicationStaffApiOutContract {
  Id: string;
  Name: string;
  /** @nullable */
  NationalDrugCode: string | null;
  /** @nullable */
  GenericCodeNumber: string | null;
  /** @nullable */
  AlternativeThirdPartyKey: string | null;
  IsControlledSubstance: boolean;
  DispenseUnit: string;
  /** Broad classification of service types. Each category can have its own
QuickMD.Constants.LifecycleRuleSet governing lifecycle state transitions. */
  Category: ServiceCategory;
  PatientDescription: string;
  ImageUrl: string;
  Formulations: FormulationApiContract[];
  FulfillmentPartnerNcpdpIds: string[];
}

export interface MergeMetadataStaffApiOutContract {
  IsSecondaryMergedAccount?: boolean;
  /** @nullable */
  MainAccountMedicalRecordNumber?: string | null;
  /** @nullable */
  MainAccountId?: string | null;
  /** @nullable */
  SourceAccountsMetadata?: SourceAccountMetadataOutContractItem[] | null;
}

export interface MessageApiContract {
  /** @nullable */
  Message?: string | null;
}

/**
 * @nullable
 */
export type OauthLoginWebApiInContractClientInfo = WebClientInfoContract | null;

export interface OauthLoginWebApiInContract {
  /** @nullable */
  TelemetryId?: string | null;
  /** @nullable */
  Token?: string | null;
  /** @nullable */
  ClientInfo?: OauthLoginWebApiInContractClientInfo;
}

export type OutOrderStatus = typeof OutOrderStatus[keyof typeof OutOrderStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OutOrderStatus = {
  pendingpayment: 'pendingpayment',
  pendingauthorization: 'pendingauthorization',
  onhold: 'onhold',
  senttopharmacy: 'senttopharmacy',
  confirmed: 'confirmed',
  shipped: 'shipped',
  delivered: 'delivered',
  cancelled: 'cancelled',
} as const;

export type OutPrescriptionStatus = typeof OutPrescriptionStatus[keyof typeof OutPrescriptionStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OutPrescriptionStatus = {
  cancel: 'cancel',
  cancel_denied: 'cancel_denied',
  cancel_failed: 'cancel_failed',
  cancel_initiated: 'cancel_initiated',
  cancel_pending: 'cancel_pending',
  cancel_success: 'cancel_success',
  cancel_trans_failed: 'cancel_trans_failed',
  cancelled: 'cancelled',
  pending: 'pending',
  printed: 'printed',
  rx_change_approved_with_changes: 'rx_change_approved_with_changes',
  rx_change_denied: 'rx_change_denied',
  rx_change_failed: 'rx_change_failed',
  rx_change_requested: 'rx_change_requested',
  rx_change_sent: 'rx_change_sent',
  rx_renewal_denied: 'rx_renewal_denied',
  rx_renewal_failed: 'rx_renewal_failed',
  rx_renewal_replace: 'rx_renewal_replace',
  xmit: 'xmit',
  xmit_failed: 'xmit_failed',
} as const;

export type OutShipmentCarrier = typeof OutShipmentCarrier[keyof typeof OutShipmentCarrier];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OutShipmentCarrier = {
  fedex: 'fedex',
  usps: 'usps',
  ups: 'ups',
  other: 'other',
} as const;

export type OutShipmentStatus = typeof OutShipmentStatus[keyof typeof OutShipmentStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OutShipmentStatus = {
  preparing: 'preparing',
  shipped: 'shipped',
  outfordelivery: 'outfordelivery',
  delivered: 'delivered',
  exceptionreported: 'exceptionreported',
  voided: 'voided',
} as const;

/**
 * A package covering a visit, for display as "Quit 7-OH Plan: Visit 2 of 5". Shared by the patient, provider and
admin APIs - the same visit reads identically whoever is looking.
 */
export interface PackageVisitCoverageApiOutContract {
  /** @nullable */
  Name?: string | null;
  /** Visits of this visit type the cover grants in total - the "5" in "Visit 2 of 5". This is the allowance the
patient bought, so changing the package afterwards does not move it. */
  AllowedQuantity?: number;
  /** Visits of this visit type still unspent, as they stand now rather than when this visit was booked. Unlike
Pwrdby.QuickMD.Api.Contracts.Visits.PackageVisitCoverageApiOutContract.Position it keeps changing: later bookings spend from it, and cancelling gives one back. */
  RemainingQuantity?: number;
  /** Which covered visit this one is - the "2" in "Visit 2 of 5". For a booked visit it is counted from the
visits already drawn against the cover, so it is fixed for that visit's life: booking a third does not
renumber the second, and visits cancelled or left unresolved gave theirs back and are not counted. On a
reservation, where no visit exists yet, it is the one about to be booked. */
  Position?: number;
}

/**
 * @nullable
 */
export type PasswordLoginWebApiInContractClientInfo = WebClientInfoContract | null;

export interface PasswordLoginWebApiInContract {
  /** @nullable */
  TelemetryId?: string | null;
  /** @nullable */
  Email?: string | null;
  /** @nullable */
  Password?: string | null;
  /** @nullable */
  ClientInfo?: PasswordLoginWebApiInContractClientInfo;
}

/**
 * @nullable
 */
export type PatientAccountInformationAdminApiInContractPhoneNumber = PhoneApiContract | null;

/**
 * @nullable
 */
export type PatientAccountInformationAdminApiInContractAddress = AddressApiContract | null;

/**
 * @nullable
 */
export type PatientAccountInformationAdminApiInContractEmergencyContact = PatientEmergencyContactApiContract | null;

export interface PatientAccountInformationAdminApiInContract {
  /** @nullable */
  Email?: string | null;
  /** @nullable */
  FirstName?: string | null;
  /** @nullable */
  LastName?: string | null;
  /** @nullable */
  BirthDate?: string | null;
  /** @nullable */
  PreferredName?: string | null;
  /** @nullable */
  PharmacyId?: string | null;
  /** @nullable */
  PhoneNumber?: PatientAccountInformationAdminApiInContractPhoneNumber;
  /** @nullable */
  Address?: PatientAccountInformationAdminApiInContractAddress;
  /** @nullable */
  EmergencyContact?: PatientAccountInformationAdminApiInContractEmergencyContact;
}

export interface PatientAccountRestrictionAdminApiInContract {
  /** @nullable */
  Message?: string | null;
  /** @nullable */
  PatientId?: string | null;
  /** @nullable */
  RestrictionStatus?: string | null;
}

/**
 * The package covering this visit, or null when none does.
 * @nullable
 */
export type PatientAdminVisitTypeInfoApiOutContractCoverage = VisitCoverageApiOutContract | null;

export interface PatientAdminVisitTypeInfoApiOutContract {
  CreditAmount: number;
  /** What this visit will cost the patient, which is zero when a package they already own covers it. Quoted here
so the visit can be created at the price that was shown. */
  Price?: number;
  /**
   * The package covering this visit, or null when none does.
   * @nullable
   */
  Coverage?: PatientAdminVisitTypeInfoApiOutContractCoverage;
}

export interface PatientAlertStaffApiInContract {
  /** @nullable */
  Message?: string | null;
  IsPrivate?: boolean;
}

export interface PatientAlertSummaryStaffApiOutContract {
  Count?: number;
  /** @nullable */
  LastUpdateDateTime?: string | null;
  HasUnread?: boolean;
}

export interface PatientAllergyApiInContract {
  /** @nullable */
  Name?: string | null;
  /** @nullable */
  Severity?: string | null;
}

/**
 * @nullable
 */
export type PatientAllergyApiOutContractAuthor = AuthorWithTypeApiOutContract | null;

export interface PatientAllergyApiOutContract {
  /** @nullable */
  AllergyId?: string | null;
  /** @nullable */
  Name?: string | null;
  /** @nullable */
  Severity?: string | null;
  /** @nullable */
  Author?: PatientAllergyApiOutContractAuthor;
}

export interface PatientAllergyCollectionApiOutContract {
  HasNoAllergyConfirmation?: boolean;
  /** @nullable */
  Allergies?: PatientAllergyApiOutContract[] | null;
}

/**
 * @nullable
 */
export type PatientAuditLogAdminApiOutContractUser = AuthorWithTypeApiOutContract | null;

export interface PatientAuditLogAdminApiOutContract {
  /** @nullable */
  User?: PatientAuditLogAdminApiOutContractUser;
  /** @nullable */
  Message?: string | null;
  /** @nullable */
  CreateDateTime?: string | null;
}

export interface PatientCreditAmountAdminApiInContract {
  Type: CreditType;
  CreditAmountChange: number;
  ReasonGlobalKey: string;
  /** @nullable */
  Comment?: string | null;
  /** @nullable */
  ExpiresAtDateOverride?: string | null;
}

export interface PatientDrugScreenStatusStaffApiOutContract {
  /** @nullable */
  FileId?: string | null;
  /** @nullable */
  CompleteDate?: string | null;
  /** @nullable */
  ExpireDate?: string | null;
  /** @nullable */
  Status?: string | null;
}

/**
 * @nullable
 */
export type PatientEmergencyContactApiContractPhoneNumber = PhoneApiContract | null;

export interface PatientEmergencyContactApiContract {
  /** @nullable */
  FirstName?: string | null;
  /** @nullable */
  LastName?: string | null;
  /** @nullable */
  Relationship?: string | null;
  /** @nullable */
  IsAuthorized?: boolean | null;
  /** @nullable */
  PhoneNumber?: PatientEmergencyContactApiContractPhoneNumber;
}

export interface PatientGeneralInformationStaffApiInContract {
  /** @nullable */
  HeightInches?: number | null;
  /** @nullable */
  WeightPounds?: number | null;
  /** @nullable */
  Gender?: string | null;
  /** @nullable */
  MaritalStatus?: string | null;
  /** @nullable */
  GenderIdentity?: string | null;
  /** @nullable */
  RacialBackground?: string | null;
}

export interface PatientIdentityVerificationChannelApiInContract {
  /** @nullable */
  VerificationChannel?: string | null;
}

export interface PatientIdentityVerificationStaffApiOutContract {
  /** @nullable */
  Status?: string | null;
  /** @nullable */
  RequestDateTime?: string | null;
}

/**
 * @nullable
 */
export type PatientListItemStaffApiOutContractPhoneNumber = PhoneApiContract | null;

/**
 * @nullable
 */
export type PatientListItemStaffApiOutContractIdentityVerification = PatientIdentityVerificationStaffApiOutContract | null;

/**
 * @nullable
 */
export type PatientListItemStaffApiOutContractDrugScreen = PatientDrugScreenStatusStaffApiOutContract | null;

export interface PatientListItemStaffApiOutContract {
  /** @nullable */
  PatientId?: string | null;
  /** @nullable */
  MedicalRecordNumber?: string | null;
  /** @nullable */
  FirstName?: string | null;
  /** @nullable */
  LastName?: string | null;
  /** @nullable */
  Email?: string | null;
  /** @nullable */
  BirthDate?: string | null;
  /** @nullable */
  Gender?: string | null;
  /** @nullable */
  ImageUrl?: string | null;
  /** @nullable */
  StateCode?: string | null;
  /** @nullable */
  LastSeenDateTime?: string | null;
  /** @nullable */
  RestrictionStatus?: string | null;
  InPersonComplianceStatus?: InPersonComplianceStatusOutContract;
  /** @nullable */
  PhoneNumber?: PatientListItemStaffApiOutContractPhoneNumber;
  /** @nullable */
  IdentityVerification?: PatientListItemStaffApiOutContractIdentityVerification;
  /** @nullable */
  DrugScreen?: PatientListItemStaffApiOutContractDrugScreen;
  /** @nullable */
  NextVisitDateTimeUtc?: string | null;
  HasActiveSubscriptions?: boolean;
  IsMergedMainAccount?: boolean;
}

export interface PatientMergeAdminApiInContract {
  SourcePatientIds: string[];
  /** @nullable */
  TargetPatientAccountRestrictionStatus?: string | null;
}

export interface PatientMessageStaffApiContract {
  /** @nullable */
  Message?: string | null;
  /** @nullable */
  PatientId?: string | null;
}

/**
 * A package the patient bought, as they bought it. Shared by the patient and admin APIs, so the same purchase reads
identically whoever is looking.
 */
export interface PatientPackageApiOutContract {
  /** @nullable */
  Id?: string | null;
  /** @nullable */
  Name?: string | null;
  /**
   * The service the package is sold against, for example Medication-Assisted Treatment.
   * @nullable
   */
  ServiceTypeName?: string | null;
  /** What the patient paid. Repricing the package afterwards does not move it. */
  Price?: number;
  /** Whether the package is still within its validity window. It says nothing about what is left to spend: an
active package can have every visit used, and an expired one can have visits it is now too late to use. */
  IsActive?: boolean;
  /** Whether any covered visit type still has a visit left. Independent of Pwrdby.QuickMD.Api.Contracts.Packages.PatientPackageApiOutContract.IsActive. */
  HasRemainingVisits?: boolean;
  PurchasedDateTimeUtc?: string;
  ValidUntilDateTimeUtc?: string;
  /**
   * Every visit type the package covers, whether or not any of its allowance is left.
   * @nullable
   */
  VisitTypes?: PatientPackageVisitTypeApiOutContract[] | null;
}

export interface PatientPackageCancellationAdminApiInContract {
  /**
   * Optional free-text reason the admin gives for cancelling the package. Stored on the package for tracking.
   * @maxLength 500
   * @nullable
   */
  Reason?: string | null;
}

export interface PatientPackageVisitTypeAdjustmentAdminApiInContract {
  VisitTypeId: string;
  VisitCount: number;
}

/**
 * One visit type a package covers, and how much of that allowance the patient still holds.
 */
export interface PatientPackageVisitTypeApiOutContract {
  /** @nullable */
  VisitTypeId?: string | null;
  /** @nullable */
  VisitTypeName?: string | null;
  /** Visits of this type the package currently grants - the "of 6" in "3 of 6". Moves when an admin adjusts. */
  AllowedQuantity?: number;
  /** Visits of this type still unspent. Booking a covered visit takes one; cancelling it gives one back. */
  RemainingQuantity?: number;
  /** Visits of this type bought at purchase. Never changes, so it always shows what was originally purchased. */
  PurchasedQuantity?: number;
}

export interface PatientPackageVisitsAdjustmentAdminApiInContract {
  Adjustments: PatientPackageVisitTypeAdjustmentAdminApiInContract[];
  Reason: string;
  /** @nullable */
  Comment?: string | null;
}

/**
 * @nullable
 */
export type PatientStaffApiOutContractPhoneNumber = PhoneApiContract | null;

/**
 * @nullable
 */
export type PatientStaffApiOutContractAddress = AddressApiContract | null;

/**
 * @nullable
 */
export type PatientStaffApiOutContractEmergencyContact = PatientEmergencyContactApiContract | null;

/**
 * @nullable
 */
export type PatientStaffApiOutContractIdentityVerification = PatientIdentityVerificationStaffApiOutContract | null;

/**
 * @nullable
 */
export type PatientStaffApiOutContractDrugScreen = PatientDrugScreenStatusStaffApiOutContract | null;

/**
 * @nullable
 */
export type PatientStaffApiOutContractPharmacy = PharmacyApiOutContract | null;

/**
 * @nullable
 */
export type PatientStaffApiOutContractAllergyCollection = PatientAllergyCollectionApiOutContract | null;

/**
 * @nullable
 */
export type PatientStaffApiOutContractPrescriptionSummary = CounterSummaryApiContract | null;

/**
 * @nullable
 */
export type PatientStaffApiOutContractVisitSummary = PatientVisitSummaryStaffApiOutContract | null;

/**
 * @nullable
 */
export type PatientStaffApiOutContractAlertSummary = PatientAlertSummaryStaffApiOutContract | null;

/**
 * @nullable
 */
export type PatientStaffApiOutContractIntakeFormSummary = CounterSummaryApiContract | null;

/**
 * @nullable
 */
export type PatientStaffApiOutContractMediaFileSummary = CounterSummaryApiContract | null;

/**
 * @nullable
 */
export type PatientStaffApiOutContractPrescriptionMonitoringProgram = PrescriptionMonitoringProgramStaffApiOutContract | null;

/**
 * @nullable
 */
export type PatientStaffApiOutContractMergeMetadata = MergeMetadataStaffApiOutContract | null;

export interface PatientStaffApiOutContract {
  /** @nullable */
  PatientId?: string | null;
  /** @nullable */
  MedicalRecordNumber?: string | null;
  /** @nullable */
  Email?: string | null;
  /** @nullable */
  FirstName?: string | null;
  /** @nullable */
  LastName?: string | null;
  /** @nullable */
  PreferredName?: string | null;
  /** @nullable */
  BirthDate?: string | null;
  /** @nullable */
  Gender?: string | null;
  /** @nullable */
  ImageUrl?: string | null;
  /** @nullable */
  MaritalStatus?: string | null;
  /** @nullable */
  GenderIdentity?: string | null;
  /** @nullable */
  RacialBackground?: string | null;
  /** @nullable */
  HeightInches?: number | null;
  /** @nullable */
  WeightPounds?: number | null;
  CreditAmount?: number;
  ReferralCreditAmount?: number;
  /** @nullable */
  RestrictionStatus?: string | null;
  InPersonComplianceStatus?: InPersonComplianceStatusOutContract;
  IsRefillAllowed?: boolean;
  /** @nullable */
  TreatSyncError?: string | null;
  /** @nullable */
  HomeDeliveryInterest?: boolean | null;
  /** @nullable */
  CreateDateTimeUtc?: string | null;
  /** @nullable */
  PhoneNumber?: PatientStaffApiOutContractPhoneNumber;
  /** @nullable */
  Address?: PatientStaffApiOutContractAddress;
  /** @nullable */
  EmergencyContact?: PatientStaffApiOutContractEmergencyContact;
  /** @nullable */
  IdentityVerification?: PatientStaffApiOutContractIdentityVerification;
  /** @nullable */
  DrugScreen?: PatientStaffApiOutContractDrugScreen;
  /** @nullable */
  Pharmacy?: PatientStaffApiOutContractPharmacy;
  /** @nullable */
  AllergyCollection?: PatientStaffApiOutContractAllergyCollection;
  /** @nullable */
  PrescriptionSummary?: PatientStaffApiOutContractPrescriptionSummary;
  /** @nullable */
  VisitSummary?: PatientStaffApiOutContractVisitSummary;
  /** @nullable */
  AlertSummary?: PatientStaffApiOutContractAlertSummary;
  /** @nullable */
  IntakeFormSummary?: PatientStaffApiOutContractIntakeFormSummary;
  /** @nullable */
  MediaFileSummary?: PatientStaffApiOutContractMediaFileSummary;
  /** @nullable */
  PrescriptionMonitoringProgram?: PatientStaffApiOutContractPrescriptionMonitoringProgram;
  /** @nullable */
  AccountInfoUpdateDateTime?: string | null;
  /** @nullable */
  Cohorts?: string[] | null;
  IsMergedMainAccount?: boolean;
  /** @nullable */
  MergeMetadata?: PatientStaffApiOutContractMergeMetadata;
}

/**
 * @nullable
 */
export type PatientVisitListItemStaffApiOutContractProvider = VisitDoctorStaffApiOutContract | null;

export interface PatientVisitListItemStaffApiOutContract {
  VisitId?: string;
  VisitDateTime?: string;
  ServiceTypeName?: string;
  VisitTypeName?: string;
  Method?: string;
  Status?: string;
  TimeZone?: string;
  IsMedicationAssistedTreatment?: boolean;
  /** @nullable */
  Provider?: PatientVisitListItemStaffApiOutContractProvider;
  /** Set when a package the patient owns paid for this visit. */
  Coverage?: VisitCoverageApiOutContract;
}

export interface PatientVisitSummaryStaffApiOutContract {
  CountPast?: number;
  CountUpcoming?: number;
}

export interface PaymentCreditCardApiInContract {
  Address: AddressApiContract;
  IsDefault?: boolean;
  EncryptedMetadata: EncryptedCreditCardMetadataApiContract;
}

export interface PaymentCreditCardApiOutContract {
  /** @nullable */
  Id?: string | null;
  /** @nullable */
  Number?: string | null;
  /** @nullable */
  Type?: string | null;
  /** @nullable */
  Expiry?: string | null;
  IsDefault?: boolean;
}

/**
 * @nullable
 */
export type PharmacyApiOutContractAddress = AddressApiContract | null;

export interface PharmacyApiOutContract {
  /** @nullable */
  PharmacyId?: string | null;
  /** @nullable */
  Name?: string | null;
  /** @nullable */
  NcpdpId?: string | null;
  /** @nullable */
  Phone?: string | null;
  /** @nullable */
  Address?: PharmacyApiOutContractAddress;
}

/**
 * @nullable
 */
export type PharmacyListItemApiOutContractAddress = AddressApiContract | null;

export interface PharmacyListItemApiOutContract {
  /** @nullable */
  PharmacyId: string | null;
  /** @nullable */
  Name: string | null;
  /** @nullable */
  Phone: string | null;
  IsErxEnabled?: boolean;
  IsEpcsEnabled?: boolean;
  IsRetailStore?: boolean;
  Is24Hrs?: boolean;
  IsMailOrder?: boolean;
  IsSpeciality?: boolean;
  IsLTC?: boolean;
  DistanceMiles?: number;
  /** @nullable */
  Address: PharmacyListItemApiOutContractAddress;
}

export interface PhoneApiContract {
  /** @nullable */
  CountryCode?: string | null;
  /** @nullable */
  Prefix?: string | null;
  /** @nullable */
  Number?: string | null;
}

export interface PrescriptionAuthorApiOutContract {
  /** @nullable */
  FirstName?: string | null;
  /** @nullable */
  LastName?: string | null;
  /** @nullable */
  Designation?: string | null;
}

/**
 * @nullable
 */
export type PrescriptionLastOrderApiOutContractShippingAddress = AddressApiContract | null;

/**
 * @nullable
 */
export type PrescriptionLastOrderApiOutContractShipment = ShipmentSummaryApiOutContract | null;

export interface PrescriptionLastOrderApiOutContract {
  Status: OutOrderStatus;
  Date: string;
  /** @nullable */
  ShippingAddress?: PrescriptionLastOrderApiOutContractShippingAddress;
  /** @nullable */
  Shipment?: PrescriptionLastOrderApiOutContractShipment;
}

export interface PrescriptionMonitoringProgramStaffApiOutContract {
  /** @nullable */
  LastSeenDateTimeUtc?: string | null;
}

/**
 * @nullable
 */
export type PrescriptionStaffApiOutContractPharmacy = PharmacyApiOutContract | null;

/**
 * @nullable
 */
export type PrescriptionStaffApiOutContractDoctor = PrescriptionAuthorApiOutContract | null;

/**
 * @nullable
 */
export type PrescriptionStaffApiOutContractLastOrder = PrescriptionLastOrderApiOutContract | null;

/**
 * @nullable
 */
export type PrescriptionStaffApiOutContractStatus = OutPrescriptionStatus | null;

export interface PrescriptionStaffApiOutContract {
  /** @nullable */
  Type?: string | null;
  /** @nullable */
  Platform?: string | null;
  /** @nullable */
  Brand?: string | null;
  /** @nullable */
  DrugName?: string | null;
  DispenseAmount?: number;
  /** @nullable */
  DispenseUnits?: string | null;
  /** @nullable */
  Quantity?: number | null;
  /** @nullable */
  Dosage?: string | null;
  /** @nullable */
  CreatedAt?: string | null;
  /** @nullable */
  Directions?: string | null;
  /** @nullable */
  Frequency?: string | null;
  /** @nullable */
  Duration?: number | null;
  /** @nullable */
  Refills?: number | null;
  /** @nullable */
  Pharmacy?: PrescriptionStaffApiOutContractPharmacy;
  /** @nullable */
  Doctor?: PrescriptionStaffApiOutContractDoctor;
  /** @nullable */
  PharmacyPartner?: string | null;
  /** @nullable */
  TotalFillsRemaining?: number | null;
  /** @nullable */
  PrescriptionId?: string | null;
  /** @nullable */
  Note?: string | null;
  /** @nullable */
  LastOrder?: PrescriptionStaffApiOutContractLastOrder;
  /** @nullable */
  Status?: PrescriptionStaffApiOutContractStatus;
  /**
   * Surescripts error (`{Code}: {Description}`) when the prescription failed to reach the pharmacy; null otherwise.
   * @nullable
   */
  Error?: string | null;
}

export interface ProblemDetails {
  /** @nullable */
  type?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  status?: number | null;
  /** @nullable */
  detail?: string | null;
  /** @nullable */
  instance?: string | null;
  [key: string]: unknown;
}

export interface QuestionnaireAnswerApiOutContract {
  /** @nullable */
  Question?: string | null;
  /** @nullable */
  Answer?: string | null;
}

export interface QuestionnaireSessionApiOutContract {
  /** @nullable */
  QuestionnaireSessionId?: string | null;
  IsCompleted?: boolean;
  /** @nullable */
  CompleteDateTime?: string | null;
  /** @nullable */
  Answers?: QuestionnaireAnswerApiOutContract[] | null;
}

export interface QuestionnaireSessionListItemStaffApiOutContract {
  /** @nullable */
  QuestionnaireSessionId?: string | null;
  /** @nullable */
  QuestionnaireKey?: string | null;
  /** @nullable */
  CompleteDateTime?: string | null;
  /** @nullable */
  VisitTypeName?: string | null;
}

export interface RescheduleVisitAdminApiInContract {
  /** @nullable */
  VisitId?: string | null;
  /** @nullable */
  ProviderId?: string | null;
  /** @nullable */
  Method?: string | null;
  /** @nullable */
  DateTime?: string | null;
  /** @nullable */
  TimeZone?: string | null;
}

export interface ScheduleVisitTypeGroupStaffApiOutContract {
  VisitTypeGroupId: string;
  Name: string;
  /** @nullable */
  Description?: string | null;
  /** @nullable */
  Abbreviation?: string | null;
  /** The default VisitTypeGroup is applied to all occurrences that do not have a specific VisitTypeGroup assigned. */
  IsDefault: boolean;
}

export interface ScheduledDoctorAvailabilityDateTimeRangeAdminApiOutContract {
  /**
   * Date and time to load calendar from. Must be encoded to be used in url. Example of encoded state: 2022-07-21T00%3A00%3A00.000%2B00%3A00.
   * @nullable
   */
  FromDateTime?: string | null;
  /**
   * toDateTime	Date and time to load calendar to. Must be encoded to be used in url. Must be greater than fromDateTime. Example of encoded state: 2022-07-21T00%3A00%3A00.000%2B00%3A00.
   * @nullable
   */
  ToDateTime?: string | null;
  /** @nullable */
  StateCodes?: string[] | null;
}

export interface ScheduledDoctorVisitTypeAdminApiOutContract {
  /** @nullable */
  Name?: string | null;
  /** @nullable */
  StateCodes?: string[] | null;
}

/**
 * Broad classification of service types. Each category can have its own
QuickMD.Constants.LifecycleRuleSet governing lifecycle state transitions.
 */
export type ServiceCategory = typeof ServiceCategory[keyof typeof ServiceCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ServiceCategory = {
  WeightLoss: 'WeightLoss',
  MedicationAssistedTreatment: 'MedicationAssistedTreatment',
  MenopauseHormoneTherapy: 'MenopauseHormoneTherapy',
  MentalHealth: 'MentalHealth',
} as const;

export interface ServiceTypeAdminApiInContract {
  Name: string;
  Description: string;
  Abbreviation: string;
  /** @nullable */
  VisitTypes?: VisitTypeAdminApiInContract[] | null;
}

export interface ServiceTypeAdminApiOutContract {
  /** @nullable */
  ServiceTypeId?: string | null;
  /** @nullable */
  Name?: string | null;
  /** @nullable */
  Abbreviation?: string | null;
  /** @nullable */
  Description?: string | null;
  /** @nullable */
  VisitTypes?: VisitTypeAdminApiOutContract[] | null;
}

export interface ServiceTypeListItemAdminApiOutContract {
  ServiceTypeId?: string;
  Name?: string;
  Abbreviation?: string;
  /** @nullable */
  Category?: string | null;
  VisitTypes?: VisitTypeListItemAdminApiOutContract[];
}

export interface ShipmentSummaryApiOutContract {
  ShipmentId?: string;
  TrackingNumber?: string;
  Carrier?: OutShipmentCarrier;
  Status?: OutShipmentStatus;
  ShippedDate?: string;
  /** @nullable */
  EstimatedDeliveryDate?: string | null;
  /** @nullable */
  TrackingUrl?: string | null;
}

export interface ShippingOptionAdminApiContract {
  /**
   * The shipping option's global key. Null when the admin is creating a brand-new option that has not
been persisted yet (no key assigned); on update it identifies the existing option to reconcile against.
   * @nullable
   */
  ShippingOptionId?: string | null;
  Name: string;
  Price: number;
  MinimumDays: number;
  MaximumDays: number;
}

/**
 * Controls whether a delivery signature is required when shipping medications from a fulfillment partner.
 */
export type SignatureRequirementContract = typeof SignatureRequirementContract[keyof typeof SignatureRequirementContract];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SignatureRequirementContract = {
  always: 'always',
  never: 'never',
  controlledsubstancesonly: 'controlledsubstancesonly',
} as const;

export interface SourceAccountMetadataOutContractItem {
  MedicalRecordNumber: string;
  Id: string;
}

export interface TokenWithPasswordApiContract {
  /** @nullable */
  Token?: string | null;
  /** @nullable */
  Password?: string | null;
}

export interface TreatmentCenterApiOutContract {
  TreatmentCenterId: string;
  Name: string;
  StreetAddress1: string;
  /** @nullable */
  StreetAddress2?: string | null;
  City: string;
  StateCode: string;
  PostalCode: string;
  Country: string;
  PhoneNumber: string;
  IsTemporary?: boolean;
  IsActive?: boolean;
}

/**
 * @nullable
 */
export type UpdateDoctorAdminApiInContractPhoneNumber = PhoneApiContract | null;

export interface UpdateDoctorAdminApiInContract {
  /** @nullable */
  Email?: string | null;
  /** @nullable */
  FirstName?: string | null;
  /** @nullable */
  LastName?: string | null;
  /** @nullable */
  Prefix?: string | null;
  /** @nullable */
  Suffix?: string | null;
  IsExcludedFromMarketingReports?: boolean;
  /** @nullable */
  NationalProviderIdentifier?: string | null;
  /** @nullable */
  ProfessionalTitles?: string[] | null;
  /** @nullable */
  PhoneNumber?: UpdateDoctorAdminApiInContractPhoneNumber;
}

/**
 * @nullable
 */
export type UpdateMediaFileStaffApiInContractDrugScreen = MediaFileDrugScreenStaffApiInContract | null;

export interface UpdateMediaFileStaffApiInContract {
  /** @nullable */
  Tags?: string[] | null;
  /** @nullable */
  DrugScreen?: UpdateMediaFileStaffApiInContractDrugScreen;
}

export interface UpdateOrderShippingAddressAdminApiInContract {
  PatientId: string;
  OrderId: string;
  Address1: string;
  /** @nullable */
  Address2?: string | null;
  City: string;
  Zip: string;
  /** @nullable */
  DeliveryInstructions?: string | null;
}

export interface UpdateProfileAdminApiInContract {
  /** @nullable */
  FirstName?: string | null;
  /** @nullable */
  LastName?: string | null;
  /** @nullable */
  Prefix?: string | null;
  /** @nullable */
  Suffix?: string | null;
  /** @nullable */
  TimeZone?: string | null;
}

export interface UserListAdminApiOutContract {
  TotalCount?: number;
  /** @nullable */
  Users?: UserListItemAdminApiOutContract[] | null;
}

/**
 * @nullable
 */
export type UserListItemAdminApiOutContractScheduleRange = DoctorScheduleRangeAdminApiOutContract | null;

export interface UserListItemAdminApiOutContract {
  /** @nullable */
  UserId?: string | null;
  /** @nullable */
  UserType?: string | null;
  /** @nullable */
  FirstName?: string | null;
  /** @nullable */
  LastName?: string | null;
  /** @nullable */
  Email?: string | null;
  /** @nullable */
  Prefix?: string | null;
  /** @nullable */
  Suffix?: string | null;
  /** @nullable */
  ImageUrl?: string | null;
  IsVerified?: boolean;
  IsActive?: boolean;
  /** @nullable */
  VisitTypes?: UserVisitTypeListItemAdminApiOutContract[] | null;
  /** @nullable */
  VisitTypeVisibilityOverrideStatus?: string | null;
  /** @nullable */
  ScheduleRange?: UserListItemAdminApiOutContractScheduleRange;
}

export interface UserVisitTypeListItemAdminApiOutContract {
  /** @nullable */
  VisitTypeName?: string | null;
  /** @nullable */
  StateCodes?: string[] | null;
}

/**
 * An async visit's stored patient preference: the confirmed current medication and the chosen delivery option.
A null Pwrdby.QuickMD.Staff.Api.Contracts.Visits.VisitPatientPreferenceStaffApiOutContract.Pharmacy means home delivery; a value means pickup at that pharmacy.
 * @nullable
 */
export type VisitAdminApiOutContractPatientPreference = VisitPatientPreferenceStaffApiOutContract | null;

export interface VisitAdminApiOutContract {
  VisitId?: string;
  /** Set when a package the patient owns paid for this visit. */
  Coverage?: VisitCoverageApiOutContract;
  PatientId?: string;
  /** @nullable */
  DoctorId?: string | null;
  VisitTypeId?: string;
  ServiceTypeName?: string;
  VisitTypeName?: string;
  Method?: string;
  Status?: string;
  FromDateTime?: string;
  ToDateTime?: string;
  TimeZone?: string;
  StateCode?: string;
  Price?: number;
  IsPriceChanged?: boolean;
  IsVisitTypeAvailable?: boolean;
  IsCancellationAllowed?: boolean;
  IsNewForPatient?: boolean;
  IsNewForServiceType?: boolean;
  IsNewPatientVisit?: boolean;
  IsMedicationAssistedTreatment?: boolean;
  Notes?: VisitMedicalRecordApiOutContract[];
  PatientInstructions?: VisitMedicalRecordApiOutContract[];
  IcdCodes?: IcdCodeStaffApiOutContract[];
  /**
   * An async visit's stored patient preference: the confirmed current medication and the chosen delivery option.
A null Pwrdby.QuickMD.Staff.Api.Contracts.Visits.VisitPatientPreferenceStaffApiOutContract.Pharmacy means home delivery; a value means pickup at that pharmacy.
   * @nullable
   */
  PatientPreference?: VisitAdminApiOutContractPatientPreference;
}

export type VisitCancellationReasonLookupItemOutContract = LookupItemOutContract & {
  /** When true, this reason is offered for asynchronous visits. */
  AppliesToAsyncVisit?: boolean;
};

/**
 * @nullable
 */
export type VisitCollectionItemAdminApiOutContractProvider = VisitDoctorCollectionItemAdminApiOutContract | null;

export interface VisitCollectionItemAdminApiOutContract {
  VisitId?: string;
  /** Set when a package the patient owns paid for this visit. */
  Coverage?: VisitCoverageApiOutContract;
  VisitNumber?: string;
  VisitTypeName?: string;
  VisitDateTime?: string;
  CreateDateTime?: string;
  Method?: string;
  Status?: string;
  PaymentTransactionId?: string;
  IsNewForPatient?: boolean;
  IsNewForServiceType?: boolean;
  IsNewPatientVisit?: boolean;
  IsPriceChanged?: boolean;
  IsVisitTypeAvailable?: boolean;
  IsCancellationAllowed?: boolean;
  Patient?: VisitPatientCollectionItemStaffApiOutContract;
  /** @nullable */
  Provider?: VisitCollectionItemAdminApiOutContractProvider;
}

export interface VisitCollectionItemAdminApiOutContractPaginationItemCollectionApiOutContract {
  /** @nullable */
  Items?: VisitCollectionItemAdminApiOutContract[] | null;
  TotalCount?: number;
}

/**
 * A package covering a visit, for display as "Quit 7-OH Plan: Visit 2 of 5". Shared by the patient, provider and
admin APIs - the same visit reads identically whoever is looking.
 * @nullable
 */
export type VisitCoverageApiOutContractPackage = PackageVisitCoverageApiOutContract | null;

/**
 * A grant program covering a visit. Unlike a package there is no allowance or position to report - the grant funds
the visit outright - so only its name is shown. Shared by the patient, provider and admin APIs.
 * @nullable
 */
export type VisitCoverageApiOutContractGrantProgram = GrantProgramVisitCoverageApiOutContract | null;

/**
 * What is covering a visit - a package the patient bought, or a grant program funding it. At most one applies;
the other is null, and the whole object is null when nothing covers the visit. Shared by the patient, provider
and admin APIs - the same visit reads identically whoever is looking.
 */
export interface VisitCoverageApiOutContract {
  /**
   * A package covering a visit, for display as "Quit 7-OH Plan: Visit 2 of 5". Shared by the patient, provider and
admin APIs - the same visit reads identically whoever is looking.
   * @nullable
   */
  Package?: VisitCoverageApiOutContractPackage;
  /**
   * A grant program covering a visit. Unlike a package there is no allowance or position to report - the grant funds
the visit outright - so only its name is shown. Shared by the patient, provider and admin APIs.
   * @nullable
   */
  GrantProgram?: VisitCoverageApiOutContractGrantProgram;
}

export interface VisitCurrentMedicationStaffApiOutContract {
  DrugName: string;
  Dosage: string;
  Frequency: string;
}

export interface VisitDoctorCollectionItemAdminApiOutContract {
  /** @nullable */
  ProviderId?: string | null;
  Prefix?: string;
  FirstName?: string;
  LastName?: string;
  Suffix?: string;
}

export interface VisitDoctorStaffApiOutContract {
  /** @nullable */
  ProviderId?: string | null;
  FirstName?: string;
  LastName?: string;
  Prefix?: string;
  Suffix?: string;
}

/**
 * @nullable
 */
export type VisitMedicalRecordApiOutContractAuthor = AuthorApiOutContract | null;

export interface VisitMedicalRecordApiOutContract {
  /**
   * Identifier of the note or patient instruction, used by the admin endpoints that delete a single record. Null where the endpoint does not load it.
   * @nullable
   */
  Id?: string | null;
  /** @nullable */
  Message?: string | null;
  IsAddendum?: boolean;
  /** @nullable */
  DateTime?: string | null;
  /** @nullable */
  Author?: VisitMedicalRecordApiOutContractAuthor;
}

/**
 * @nullable
 */
export type VisitPatientCollectionItemStaffApiOutContractIdentityVerification = PatientIdentityVerificationStaffApiOutContract | null;

/**
 * @nullable
 */
export type VisitPatientCollectionItemStaffApiOutContractDrugScreen = PatientDrugScreenStatusStaffApiOutContract | null;

export interface VisitPatientCollectionItemStaffApiOutContract {
  /** @nullable */
  PatientId?: string | null;
  /** @nullable */
  FirstName?: string | null;
  /** @nullable */
  LastName?: string | null;
  /** @nullable */
  StateCode?: string | null;
  /** @nullable */
  IdentityVerification?: VisitPatientCollectionItemStaffApiOutContractIdentityVerification;
  /** @nullable */
  DrugScreen?: VisitPatientCollectionItemStaffApiOutContractDrugScreen;
}

/**
 * @nullable
 */
export type VisitPatientPreferenceStaffApiOutContractPharmacy = PharmacyApiOutContract | null;

/**
 * An async visit's stored patient preference: the confirmed current medication and the chosen delivery option.
A null Pwrdby.QuickMD.Staff.Api.Contracts.Visits.VisitPatientPreferenceStaffApiOutContract.Pharmacy means home delivery; a value means pickup at that pharmacy.
 */
export interface VisitPatientPreferenceStaffApiOutContract {
  /** @nullable */
  Pharmacy?: VisitPatientPreferenceStaffApiOutContractPharmacy;
  CurrentMedication: VisitCurrentMedicationStaffApiOutContract;
}

export interface VisitTypeAdminApiInContract {
  /** @nullable */
  VisitTypeId?: string | null;
  IntakeFormId: string;
  Name: string;
  Description: string;
  Duration?: number;
  Cost?: number;
  CancellationFee?: number;
  VisibilityType: string;
  IsMedicationAssistedTreatment?: boolean;
  IsPostBookingReminderRequired?: boolean;
  IsPhoneVisitCommunicationTypeAllowed?: boolean;
  IsInPerson?: boolean;
  IsAsynchronous?: boolean;
  IsNewPatientSpacingEnabled?: boolean;
  ConsentForms?: VisitTypeConsentFormAdminApiInContract[];
  /** @nullable */
  VisitTypeGroupIds?: string[] | null;
}

/**
 * @nullable
 */
export type VisitTypeAdminApiOutContractIntakeForm = VisitTypeIntakeFormAdminApiOutContract | null;

export interface VisitTypeAdminApiOutContract {
  /** @nullable */
  VisitTypeId: string | null;
  /** @nullable */
  Name: string | null;
  /** @nullable */
  Description: string | null;
  Duration: number;
  Cost: number;
  CancellationFee: number;
  /** @nullable */
  VisibilityType: string | null;
  IsMedicationAssistedTreatment: boolean;
  IsPostBookingReminderRequired: boolean;
  IsPhoneVisitCommunicationTypeAllowed: boolean;
  IsInPerson: boolean;
  IsAsynchronous: boolean;
  IsNewPatientSpacingEnabled: boolean;
  /** @nullable */
  ConsentForms: VisitTypeConsentFormAdminApiOutContract[] | null;
  /** @nullable */
  IntakeForm?: VisitTypeAdminApiOutContractIntakeForm;
  /** @nullable */
  VisitTypeGroups: ScheduleVisitTypeGroupStaffApiOutContract[] | null;
  /** @nullable */
  CreateDateTime: string | null;
}

export interface VisitTypeConsentFormAdminApiInContract {
  /** @nullable */
  ConsentFormId?: string | null;
}

export interface VisitTypeConsentFormAdminApiOutContract {
  /** @nullable */
  ConsentFormId?: string | null;
  /** @nullable */
  Name?: string | null;
}

export interface VisitTypeIntakeFormAdminApiOutContract {
  /** @nullable */
  IntakeFormId?: string | null;
  /** @nullable */
  Name?: string | null;
}

export interface VisitTypeListItemAdminApiOutContract {
  /** @nullable */
  VisitTypeId?: string | null;
  /** @nullable */
  Name?: string | null;
  Price?: number;
  Duration?: number;
  /** @nullable */
  VisibilityType?: string | null;
  IsInPerson?: boolean;
  IsAsynchronous?: boolean;
  IsNewPatientSpacingEnabled?: boolean;
}

export interface WebClientInfoContract {
  /**
   * Operating System web client is running on
   * @nullable
   */
  OsType?: string | null;
  /**
   * Web Client Type (Chrome, Safari etc)
   * @nullable
   */
  Type?: string | null;
  /**
   * Web client version
   * @nullable
   */
  Version?: string | null;
}

export type PutAdminsUserIdProfileimageBody = {
  image?: Blob;
};

export type GetBookingAvailabilityParams = {
PatientId?: string;
VisitTypeId?: string;
ProviderId?: string;
TimeZone?: string;
FromDateTime?: string;
ToDateTime?: string;
/**
 * Optional identifier of the visit being rescheduled. When it references the patient's
in-person visit, offered slots are restricted to times the provider is available at that
visit's treatment center.
 */
RescheduleVisitId?: string;
};

export type GetProvidersDoctorIdCalendarParams = {
/**
 * Date and time to load calendar from. Must be encoded to be used in url. Example of encoded state: 2022-07-21T00%3A00%3A00.000%2B00%3A00.
 */
FromDateTime?: string;
/**
 * toDateTime	Date and time to load calendar to. Must be encoded to be used in url. Must be greater than fromDateTime. Example of encoded state: 2022-07-21T00%3A00%3A00.000%2B00%3A00.
 */
ToDateTime?: string;
};

export type PostConsentformsBody = {
  Name?: string;
  FileName?: string;
  'FileStream.CanRead'?: boolean;
  'FileStream.CanWrite'?: boolean;
  'FileStream.CanSeek'?: boolean;
  'FileStream.CanTimeout'?: boolean;
  'FileStream.Length'?: number;
  'FileStream.Position'?: number;
  'FileStream.ReadTimeout'?: number;
  'FileStream.WriteTimeout'?: number;
  IndividualConsentRequired?: boolean;
  file?: Blob;
};

export type PutProvidersUserIdProfileimageBody = {
  /** The image file to upload, or null to remove the current image. */
  image?: Blob;
};

export type GetProvidersScheduledParams = {
FromDateTime?: string;
ToDateTime?: string;
SearchValue?: string;
LicenseStateCode?: string;
VisitTypeIds?: string[];
Offset?: number;
Count?: number;
};

export type PostIcdcodesBody = {
  file?: Blob;
  activeFromDate?: string;
};

export type GetLookupsParams = {
/**
 * The lookup type to retrieve items for.
 */
type?: LookupType;
};

export type GetLookups200OneItem = LookupItemOutContract | CreditReasonLookupItemOutContract | VisitCancellationReasonLookupItemOutContract;

export type GetLookups200TwoItem = LookupItemOutContract | CreditReasonLookupItemOutContract | VisitCancellationReasonLookupItemOutContract;

export type GetLookups200ThreeItem = LookupItemOutContract | CreditReasonLookupItemOutContract | VisitCancellationReasonLookupItemOutContract;

export type GetMarketingPatientsPatientIdEmbeddabletokenParams = {
tokenExpirationMinutes?: number;
};

export type PostPatientsPatientIdMediafilesBody = {
  file?: Blob;
  drugScreenCompleteDate?: string;
  drugScreenExpireDate?: string;
  tags?: string[];
};

export type GetAdminsMedicationsParams = {
/**
 * Optional case-insensitive search term to filter medications.
 */
search?: string;
};

export type PostAdminsMedicationsImagesBody = {
  /** The image file to upload. */
  image?: Blob;
};

export type PutOrdersTrackingShippedBody = {
  file?: Blob;
};

export type GetPatientsParams = {
Count?: number;
Offset?: number;
SearchValue?: string;
BirthDate?: string;
};

export type GetPatientsAutocompleteParams = {
searchValue?: string;
};

export type GetPharmaciesParams = {
PatientId?: string;
Count?: number;
SearchValue?: string;
IsErxEnabled?: boolean;
IsEpcsEnabled?: boolean;
IsRetailStore?: boolean;
Is24Hrs?: boolean;
IsMailOrder?: boolean;
IsSpeciality?: boolean;
IsLTC?: boolean;
};

export type GetPharmaciesV2Params = {
PatientId?: string;
SearchValue?: string;
ZipCode?: string;
};

export type PutProfileImageBody = {
  image?: Blob;
};

export type GetUsersParams = {
Count?: number;
Offset?: number;
SearchValue?: string;
StateCodes?: string;
VisitTypeIds?: string;
IsAdmin?: boolean;
IsDoctor?: boolean;
IsActive?: boolean;
IsVerified?: boolean;
SortOrder?: string;
};

export type GetUtilitiesLogsAccessParams = {
Email?: string;
Count?: number;
};

export type GetPatientsPatientIdLogsAuditParams = {
Count?: number;
LogType?: string;
};

export type GetVisitsParams = {
FromDateTime?: string;
ToDateTime?: string;
IsIncludeUpcoming?: boolean;
IsIncludePast?: boolean;
SearchValue?: string;
VisitTypeIds?: string[];
Statuses?: string[];
IsNewForPatient?: boolean;
IsNewForServiceType?: boolean;
DrugScreenStatuses?: string[];
IdentityVerificationStatuses?: string[];
Offset?: number;
Count?: number;
};

